









































































































import Component, { mixins } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import QsConfirmationModal from 'qs_vuetify/src/components/Dialog/QsConfirmationModal.vue';
import QsFilters from 'qs_vuetify/src/components/QsFilters.vue';
import QsList from 'qs_vuetify/src/components/QsList.vue';

import AuthenticationMixin from 'qs_vuetify/src/mixins/AuthenticationMixin';
import DataRouteGuards from 'qs_vuetify/src/mixins/DataRouteGuards';
import LazyListMixin from 'qs_vuetify/src/mixins/LazyListMixin';
import ListMixin from 'qs_vuetify/src/mixins/ListMixin';

import { ExportMimeType } from 'qs_vuetify/src/types/components';
import { PersistedCallCampaign } from 'qs_vuetify/src/types/models';
import { ErrorResponse } from 'qs_vuetify/src/types/responses';
import { RestParams, FiltersDefinition } from 'qs_vuetify/src/types/states';

import CallCampaignCard from '@/components/CallCampaign/CallCampaignCard.vue';

const auth: any = namespace('auth');
const campaigns: any = namespace('call_campaigns');
const global: any = namespace('global');
const view: any = namespace('callCampaignsViews');

@Component({
  components: {
    CallCampaignCard,
    QsConfirmationModal,
    QsFilters,
    QsList,
  },
  head: {
    title() {
      const { title, subtitle } = this.$store.state.global;
      let inner = this.$route.matched.reduce((acc, r) => {
        if (r.meta && r.meta.title) {
          return r.meta.title;
        }
        return acc;
      }, title);
      if (subtitle) {
        inner = `${subtitle} | ${inner}`;
      }
      return { inner };
    },
  },
})
export default class CallCampaigns extends mixins(
  AuthenticationMixin,
  DataRouteGuards,
  LazyListMixin,
  ListMixin,
) {
  @auth.Getter instanceId!: number | null;
  @global.Mutation addNotification!: Function;
  @global.Mutation removeNotification!: Function;

  @campaigns.Getter data!: Array<PersistedCallCampaign>;
  @campaigns.Getter error!: ErrorResponse;
  @campaigns.Getter exportUrl!: string;
  @campaigns.Getter filtersDefinition!: FiltersDefinition | null;
  @campaigns.Getter loading!: boolean;
  @campaigns.Getter slug!: string;
  @campaigns.Getter total!: number;

  @view.Mutation addSelectedItem!: any;
  @view.Getter params!: RestParams;
  @view.Mutation removeSelectedItem!: (arg: PersistedCallCampaign) => void;
  @view.Getter selectedItems!: Array<PersistedCallCampaign>;
  @view.Mutation setParams!: any;
  @view.Mutation setSelectedItems!: any;

  defaultParams = {
    per_page: 20,
    order: '-id',
    fields: [
      'id',
      'name',
      'description',
      'instance.name',
      'stats.*',
      'status',
      'created_at',
      'deleted_at',
      'updated_at',
      'created_by_user.contact_name',
      'deleted_by_user.contact_name',
      'updated_by_user.contact_name',
    ].join(','),
    'instances.id': this.instanceId,
  }

  get viewParams() {
    return {
      call_campaigns: {
        ...this.defaultParams,
        ...this.params,
      },
    };
  }

  filtersLoaded = true;
  viewStoreName = 'callCampaignsViews';

  get activeFilters(): FiltersDefinition {
    if (!this.filtersDefinition) {
      return {};
    }

    const baseFilters = {
      status: this.filtersDefinition.status,
      q: this.filtersDefinition.q,
    };

    if (this.userIsSuperadmin) {
      return {
        ...baseFilters,
        with_deleted: this.filtersDefinition.with_deleted,
      };
    }

    return baseFilters;
  }

  archive() {
    this.confirmList(
      "Archivage de campagnes d'appels",
      `Êtes-vous sûr-e de vouloir archiver ces campagnes d'appels?
      Vous ne pourrez plus faire d'appels, mais les données seront conservées.`,
      async () => {
        this.listDialog.loading = true;

        await Promise.all(this.selectedItems.filter((e) => !e.deleted_at).map(
          (e) => this.$store.dispatch('call_campaigns/destroy', e.id),
        ));

        this.listDialog.loading = false;

        this.listDialog.value = false;

        this.loadFirstPage();
      },
    );
  }

  async restore() {
    await Promise.all(this.selectedItems.filter((e) => !!e.deleted_at).map(
      (e) => this.$store.dispatch('call_campaigns/restore', e.id),
    ));

    this.loadFirstPage();
  }

  mounted() {
    this.setAction();

    this.$store.commit('call_campaigns/exportFields', [
      'id',
      'name',
    ]);

    if (this.data.length === 0) {
      this.setParams({
        ...this.defaultParams,
        ...this.params,
        page: 1,
      });
    }
  }

  async exportCsv() {
    await this.export('text/csv');
  }

  async exportXls() {
    await this.export('application/vnd.ms-excel');
  }

  @Watch('$route', { deep: true })
  onRouteChanged() {
    this.setAction();
  }

  @Watch('userIsConnected')
  onUserIsConnectedChanged(val: boolean) {
    if (val) {
      this.setAction();
    }
  }

  setAction() {
    this.$store.commit(
      'global/actions',
      this.userHas('CALL_CAMPAIGNS_CREATE') ? [
        {
          onClick: () => { this.$router.push('call_campaigns/new'); },
          color: 'primary',
          icon: 'mdi-plus',
        },
      ] : [],
    );
  }

  private async export(mimeType: ExportMimeType) {
    const params = this.actionParams;

    const generationNotification = {
      color: 'warning',
      message: 'Génération de votre fichier en cours...',
    };
    this.addNotification(generationNotification);

    await this.$store.dispatch('call_campaigns/export', {
      params,
      mimeType,
    });

    this.removeNotification(generationNotification);
    this.addNotification({
      color: 'success',
      message: 'Génération terminée!',
      timeout: -1,
      action: () => {
        document.location.href = this.exportUrl;
      },
    });
  }
}
